import clsx from 'clsx'
import Link from '@/atoms/Link/Link'
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton
} from 'react-share'

// assets
import { ReactComponent as PepperLogo } from 'public/assets/icons/PepperLogo_White.svg'

const FacebookWhiteIcon = '/assets/icons/social/facebook-white.svg'
const TwitterWhiteIcon = '/assets/icons/social/twitter-white.svg'
const LinkedInWhiteIcon = '/assets/icons/social/linkedin-white.svg'

interface Props {
  className?: string
}

function WaitlistFooter({ className }: Props): JSX.Element {
  const location = `${process.env.NEXT_PUBLIC_BASE_URL}/global-marketing-leaders`
  const title = ' '
  return (
    <div
      className={clsx(
        className,
        'flex flex-col gap-2 justify-between items-center lg:flex-row  |  pt-5 pb-8'
      )}
    >
      <div className="text-paragraph-3 | space-x-12">
        <Link href="/global-marketing-leaders/waitlist/">Register</Link>
        <Link href="/global-marketing-leaders/">Influencer List</Link>
        <Link href="/global-marketing-leaders/waitlist/">Pepper Academy</Link>
      </div>

      <Link
        href="/global-marketing-leaders/"
        className="lg:absolute | lg:transform lg:-translate-x-1/2 | lg:left-1/2"
      >
        <PepperLogo className="md:w-[150px] | md:h-[50px]" />
      </Link>

      <div className="flex items-center">
        <span className="text-paragraph-3 | mr-4">Share this page</span>

        <div className={clsx('flex gap-2 items-center', className)}>
          <FacebookShareButton
            quote={title}
            hashtag="#peppercontent"
            url={location}
          >
            <img
              className="h-6 w-6"
              title="Share on Facebook"
              src={FacebookWhiteIcon}
              alt="Share on Facebook"
            />
          </FacebookShareButton>
          <TwitterShareButton title={`${title}`} url={location}>
            <img
              className="h-6 w-6"
              title="Share on Twitter"
              src={TwitterWhiteIcon}
              alt="Share on Twitter"
            />
          </TwitterShareButton>
          <LinkedinShareButton url={location} title={`${title}`}>
            <img
              className="h-6 w-6"
              title="Share on LinkedIn"
              src={LinkedInWhiteIcon}
              alt="Share on Linkedin"
            />
          </LinkedinShareButton>
        </div>
      </div>
    </div>
  )
}

export default WaitlistFooter
